module.exports = __webpack_public_path__ + "img/Access-menu.f89dff0f.png";